import styled from 'styled-components';

export const EndAdornmentWrapper = styled.div`
  svg {
    position: absolute;
    width: 1.5rem;
    top: .75rem;
    right: 1rem;
    cursor: pointer;
  }
`;

